import { HardwareMinimumsResource as e } from "./resources/HardwareMinimumsResource.js";
import { ActivitiesInternalResource as t } from "./resources/ActivitiesInternalResource.js";
import { AgentConfigurationResource as n } from "./resources/agent-configuration/AgentConfigurationResource.js";
import { AgentGatewayConfiguration as r } from "./resources/AgentGatewayConfiguration.js";
import { AnnouncementsResource as i } from "./resources/AnnouncementsResource.js";
import { AnswerResource as a } from "./resources/answer/AnswerResource.js";
import { AutomationFreezesResource as o } from "./resources/AutomationFreezesResource.js";
import { BatchAnswerResource as s } from "./resources/batch-answer/BatchAnswerResource.js";
import { CaseAssistConfigsInternalResource as c } from "./resources/CaseAssistConfigstInternalResource.js";
import { CatalogsInternalResource as l } from "./resources/CatalogsInternalResource.js";
import { ChunkInspectorResource as u } from "./resources/chunk-inspector/ChunkInspectorResource.js";
import { CommerceResource as d } from "./resources/commerce/Commerce.js";
import { ConditionResource as f } from "./resources/ConditionResource.js";
import { ConversationInspectorResource as p } from "./resources/conversation-inspector/ConversationInspectorResource.js";
import { CrawlingModuleInternalResource as m } from "./resources/CrawlingModuleInternalResource.js";
import { CRGADashboardResource as h } from "./resources/crga-dashboard/CRGADashboardResource.js";
import { DataServiceResource as g } from "./resources/DataServiceResource.js";
import { DocumentIdentityResource as _ } from "./resources/DocumentIdentityResource.js";
import { ExportServiceResource as v } from "./resources/ExportServiceResource.js";
import { ExtensionInternalResource as y } from "./resources/ExtensionInternalResource.js";
import { HostedPagesInternalResource as b } from "./resources/HostedPagesInternalResource.js";
import { InAppWidgetResource as x } from "./resources/InAppWidgetResource.js";
import { InsightPanelConfigsInternalResource as S } from "./resources/InsightPanelConfigsInternalResource.js";
import { IPXInterfaceExperimentalResource as C } from "./resources/IPXInterfaceResource.js";
import { LicenseInternalResource as w } from "./resources/LicenseInternalResource.js";
import { LogicalIndexesResource as T } from "./resources/LogicalIndexesResource.js";
import { MCPConfigurationsResource as E } from "./resources/MCPConfigurationsResource.js";
import { MCPPipelinesResource as D } from "./resources/MCPPipelinesResource.js";
import { ModelsInternalResource as O } from "./resources/ModelsInternalResource.js";
import { NextGenSearchPagesInternalResource as k } from "./resources/NextGenSearchPagesInternalResource.js";
import { NotificationEventResource as A } from "./resources/NotificationEventResource.js";
import { OrganizationCustomerKeysResource as j } from "./resources/OrganizationCustomerKeysResource.js";
import { OrganizationDefinitionResource as M } from "./resources/OrganizationDefinitionResource.js";
import { OrganizationHealthMonitoringResource as N } from "./resources/OrganizationHealthMonitoringResource.js";
import { OrganizationInternalResource as P } from "./resources/OrganizationInternalResource.js";
import { OrganizationMonitoringResource as F } from "./resources/OrganizationMonitoringResource.js";
import { OrganizationQuotasResource as I } from "./resources/OrganizationQuotasResource.js";
import { OrganizationSettingsResource as L } from "./resources/OrganizationSettingsResource.js";
import { PipelineInternalResource as R } from "./resources/PipelineInternalResource.js";
import { PipelineSettingsResource as z } from "./resources/PipelineSettingsResource.js";
import { PreviewResource as B } from "./resources/PreviewResource.js";
import { PrivateLicenseResource as V } from "./resources/PrivateLicenseResource.js";
import { PrivilegesResource as H } from "./resources/PrivilegesResource.js";
import { ProjectInternalResource as U } from "./resources/ProjectInternalResource.js";
import { ReportInternalResource as W } from "./resources/ReportInternalResource.js";
import { SalesforceSourceConfigurationInternalResource as G } from "./resources/SalesforceSourceConfigurationInternalResource.js";
import { SchemaServiceTemporaryResource as K } from "./resources/SchemaServiceTemporaryResource.js";
import { SearchDictionaryFieldsResource as q } from "./resources/SearchDictionaryFieldsResource.js";
import { SearchInterfacesInternalResource as J } from "./resources/SearchInterfacesInternalResource.js";
import { SearchPagesInternalResource as Y } from "./resources/SearchPagesInternalResource.js";
import { SecurityCacheInternalResource as X } from "./resources/SecurityCacheInternalResource.js";
import { SourcesInternalResource as Z } from "./resources/SourcesInternalResource.js";
import { WebsitesInternalResource as Q } from "./resources/WebsitesInternalResource.js";
import { PlatformClient as $ } from "@coveo/platform-client";
//#region src/PrivatePlatformClient.ts
var ee = [
	{
		key: "activitiesInternal",
		resource: t
	},
	{
		key: "agentConfiguration",
		resource: n
	},
	{
		key: "agentGatewayConfiguration",
		resource: r
	},
	{
		key: "announcements",
		resource: i
	},
	{
		key: "answer",
		resource: a
	},
	{
		key: "automationFreezes",
		resource: o
	},
	{
		key: "batchAnswer",
		resource: s
	},
	{
		key: "catalogsInternal",
		resource: l
	},
	{
		key: "caseAssistConfigsInternal",
		resource: c
	},
	{
		key: "chunkInspector",
		resource: u
	},
	{
		key: "commerce",
		resource: d
	},
	{
		key: "conversationInspector",
		resource: p
	},
	{
		key: "condition",
		resource: f
	},
	{
		key: "crawlingModuleInternal",
		resource: m
	},
	{
		key: "crgaDashboard",
		resource: h
	},
	{
		key: "dataService",
		resource: g
	},
	{
		key: "documentIdentity",
		resource: _
	},
	{
		key: "exportService",
		resource: v
	},
	{
		key: "extensionInternal",
		resource: y
	},
	{
		key: "hardwareMinimums",
		resource: e
	},
	{
		key: "inAppWidget",
		resource: x
	},
	{
		key: "insightPanelConfigsInternal",
		resource: S
	},
	{
		key: "hostedPagesInternal",
		resource: b
	},
	{
		key: "ipxInterfaceExperimental",
		resource: C
	},
	{
		key: "licenseInternal",
		resource: w
	},
	{
		key: "logicalIndexes",
		resource: T
	},
	{
		key: "mcpConfigurations",
		resource: E
	},
	{
		key: "mcpPipelines",
		resource: D
	},
	{
		key: "modelsInternal",
		resource: O
	},
	{
		key: "nextGenSearchPagesInternal",
		resource: k
	},
	{
		key: "notificationEvent",
		resource: A
	},
	{
		key: "organizationInternal",
		resource: P
	},
	{
		key: "organizationCustomerKeys",
		resource: j
	},
	{
		key: "organizationDefinition",
		resource: M
	},
	{
		key: "organizationQuotas",
		resource: I
	},
	{
		key: "organizationHealthMonitoring",
		resource: N
	},
	{
		key: "organizationMonitoring",
		resource: F
	},
	{
		key: "organizationSettings",
		resource: L
	},
	{
		key: "pipelineInternal",
		resource: R
	},
	{
		key: "pipelineSettings",
		resource: z
	},
	{
		key: "privateLicense",
		resource: V
	},
	{
		key: "preview",
		resource: B
	},
	{
		key: "privileges",
		resource: H
	},
	{
		key: "projectInternal",
		resource: U
	},
	{
		key: "reportInternalResource",
		resource: W
	},
	{
		key: "salesforceSourceConfigurationInternal",
		resource: G
	},
	{
		key: "schemaServiceTemporary",
		resource: K
	},
	{
		key: "searchDictionaryFields",
		resource: q
	},
	{
		key: "searchInterfacesInternal",
		resource: J
	},
	{
		key: "searchPagesInternal",
		resource: Y
	},
	{
		key: "sourcesInternal",
		resource: Z
	},
	{
		key: "securityCacheInternal",
		resource: X
	},
	{
		key: "websitesInternal",
		resource: Q
	}
], te = class extends $ {
	constructor(e) {
		super(e), ee.forEach(({ key: e, resource: t }) => {
			this[e] = new t(this.API, this.ServerlessAPI);
		});
	}
};
//#endregion
export { te as PrivatePlatformClient };

//# sourceMappingURL=PrivatePlatformClient.js.map